import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import { setError } from '../common/toast/toast';
import readXlsxFile from 'read-excel-file/web-worker'
import Aguardando from '../common/template/aguardando';

import { setModoTela, getLista, getListaProducao } from './relatorioHospitalActions';
import { getLista as getListaHospital } from '../hospital/hospitalActions';
import { getLista as getListaRadiologista } from '../radiologista/radiologistaActions';

import FormatUtils from '../common/formatUtils/FormatUtils';
import DateFormat from '../common/dateFormat/DateFormat';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import Select from '../common/form/select';

class RelatorioHospital extends Component {

	state = {
		linhaSelecionada: null,
		mes: String(new Date().getMonth() + 1).padStart(2, '0'),
		ano: new Date().getFullYear()
	}

	componentDidMount() {

	}

    componentWillMount() {
        this.props.getLista({
			ano: this.state.ano,
			mes: this.state.mes,
			id_hospital: this.state.id_hospital
		});
		this.props.getListaProducao({
			ano: this.state.ano,
			mes: this.state.mes,
			id_hospital: this.state.id_hospital
		});
		this.props.getListaHospital();
		this.props.getListaRadiologista();
    }

	render() {

		return (
			<Content>
				<Aguardando aguardando={this.props.aguardando} />

				<ContentCard>
					<ContentCardHeader>
						<Row>
							<Select
								options={[{ id: 2025, valor: 2025 }, { id: 2026, valor: 2026 }, { id: 2027, valor: 2027 }]}
								label='Ano *'
								cols='12 6 4 3'
								placeholder='Selecione'
								minWidth={300}
								value={this.state.ano}
								onChange={value => {
									this.setState({
										...this.state,
										ano: value
									});
								}} />
						
							<Select
								options={[
									{ id: '01', valor: 'Janeiro' },	{ id: '02', valor: 'Fevereiro' }, { id: '03', valor: 'Março' }, { id: '04', valor: 'Abril' },
									{ id: '05', valor: 'Maio' }, { id: '06', valor: 'Junho' }, { id: '07', valor: 'Julho' }, { id: '08', valor: 'Agosto' },
									{ id: '09', valor: 'Setembro' }, { id: '10', valor: 'Outubro' }, { id: '11', valor: 'Novembro' }, { id: '12', valor: 'Dezembro' }
								]}
								label='Mês *'
								cols='12 6 4 3'
								placeholder='Selecione'
								minWidth={300}
								value={this.state.mes}
								onChange={value => {
									this.setState({
										...this.state,
										mes: value
									});
								}} />

							<Select
								options={this.props.listaHospital}
								label='Hospital *'
								cols='12 6 4 3'
								placeholder='Selecione'
								minWidth={300}
								value={this.state.id_hospital}
								onChange={value => {
									this.setState({
										...this.state,
										id_hospital: value
									});
								}} />

							<div style={{ width: 110, marginTop: 8, marginLeft: 8 }}>
								<a class='btn btn-app bg-primary' style={{ marginLeft: 2, minWidth: 75 }}
									onClick={() => {
										this.props.getLista({
											ano: this.state.ano,
											mes: this.state.mes,
											id_hospital: this.state.id_hospital
										});
										this.props.getListaProducao({
											ano: this.state.ano,
											mes: this.state.mes,
											id_hospital: this.state.id_hospital
										});
									}}>
									<i class='fas fa-sync-alt'></i> Atualizar
								</a>
							</div>
						</Row>
					</ContentCardHeader>
				</ContentCard>

				{this.listaValores()}

				{this.listaProducoes()}

			</Content>
		)
	}

    listaValores() {

		let valorTotal = 0;
		let valorImpostoTotal = 0;
		let valorImpostoEscritorioTotal = 0;
		let valorLiquidoTotal = 0;

        return (
			<ContentCard>
				<ContentCardBody>
					<Table responsive striped border>
						<THead>
							<Tr>
								<Th width={300} a>Radiologista</Th>
								<Th width={100} alignRight>Total Bruto</Th>
								<Th width={100} alignRight>Imposto</Th>
								<Th width={100} alignRight>Administração</Th>
								<Th width={100} alignRight>Líquido</Th>
							</Tr>
						</THead>
						<TBody>
							{this.props.lista.map(item => {

								valorTotal += parseFloat(item.valor);
								valorImpostoTotal += parseFloat(item.valor_imposto);
								valorImpostoEscritorioTotal += parseFloat(item.valor_imposto_escritorio);
								valorLiquidoTotal += parseFloat(item.valor_liquido);

								return (
									<Tr key={`${item.competencia}`}>
										<Td width={300} alignLeft>{item.nome_radiologista}</Td>
										<Td width={100} alignRight>R$ {FormatUtils.formatarValorTelaDecimal(item.valor, 2)}</Td>
										<Td width={100} alignRight>R$ {FormatUtils.formatarValorTelaDecimal(item.valor_imposto, 2)}</Td>
										<Td width={100} alignRight>R$ {FormatUtils.formatarValorTelaDecimal(item.valor_imposto_escritorio, 2)}</Td>
										<Td width={100} alignRight>R$ {FormatUtils.formatarValorTelaDecimal(item.valor_liquido, 2)}</Td>
									</Tr>
								);
							})}
							<Tr>
								<Td width={300} bold alignLeft backgroundColor='#dedede'>Total</Td>
								<Td width={100} alignRight bold backgroundColor='#dedede'>R$ {FormatUtils.formatarValorTelaDecimal(valorTotal, 2)}</Td>
								<Td width={100} alignRight bold backgroundColor='#dedede'>R$ {FormatUtils.formatarValorTelaDecimal(valorImpostoTotal, 2)}</Td>
								<Td width={100} alignRight bold backgroundColor='#dedede'>R$ {FormatUtils.formatarValorTelaDecimal(valorImpostoEscritorioTotal, 2)}</Td>
								<Td width={100} alignRight bold backgroundColor='#dedede'>R$ {FormatUtils.formatarValorTelaDecimal(valorLiquidoTotal, 2)}</Td>
							</Tr>
						</TBody>
					</Table>
				</ContentCardBody>
			</ContentCard>                
        )
    }

	listaProducoes() {

		let totalExames = (this.props.listaProducao[0] ? this.props.listaProducao[0].exames || [] : []).map(exame => ({
			id_exame: exame.id_exame,
			quantidade: 0
		}));

		let totalGeral = 0;

        return (
            <ContentCard>
				<ContentCardBody>
					<Table responsive striped border>
						<THead>
							<Tr>
								<Th width={300} alignLeft>Radiologista</Th>
								{(this.props.listaProducao[0] ? this.props.listaProducao[0].exames || [] : []).map(exame => (
									<Th key={exame.id_exame} width={100} alignCenter>{exame.nome_exame}</Th>
								))}
								<Th width={100} alignCenter backgroundColor='#c2bebe'>Total</Th>
							</Tr>
						</THead>
						<TBody>
							{this.props.listaProducao.map(item => {

								let totalRadiologista = 0;
								
								return (
									<Tr key={item.id_exame}>
										<Td width={300} alignLeft>{item.nome_radiologista}</Td>
										{item.exames.map(exame => {

											totalRadiologista += parseInt(exame.quantidade || 0);

											totalExames = totalExames.map(itemTotal => {
												if (itemTotal.id_exame == exame.id_exame) {
													return {
														...itemTotal,
														quantidade: itemTotal.quantidade + parseInt(exame.quantidade || 0)
													};
												} else {
													return {
														...itemTotal
													};
												}
											});
											
											return (
												<Td width={100} alignCenter>{FormatUtils.formatarValorTelaDecimal(exame.quantidade, 0)}</Td>
											);
										})}
										<Td width={100} alignCenter bold backgroundColor='#c2bebe'>{FormatUtils.formatarValorTelaDecimal(totalRadiologista, 0)}</Td>
									</Tr>
								);
							})}
							<Tr>
								<Td width={300} alignLeft bold backgroundColor='#dedede'>Total</Td>
								{totalExames.map(total => {
									
									totalGeral += parseInt(total.quantidade || 0);

									return (
										<Td key={total.id_exame} alignCenter bold backgroundColor='#dedede'>{FormatUtils.formatarValorTelaDecimal(total.quantidade, 0)}</Td>
									);
								})}								
								<Td width={100} alignCenter bold backgroundColor='#c2bebe'>{FormatUtils.formatarValorTelaDecimal(totalGeral, 0)
								}</Td>
							</Tr>
						</TBody>
					</Table>
				</ContentCardBody>
			</ContentCard>
        )
    }
}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	modoTela: state.relatorioHospital.modoTela,
	aguardando: state.relatorioHospital.aguardando,
	lista: state.relatorioHospital.lista,
	listaProducao: state.relatorioHospital.listaProducao,
	listaHospital: state.hospital.listaSelect,
	listaRadiologista: state.radiologista.listaSelect
});
const mapDispatchToProps = dispatch => bindActionCreators({ 
	setModoTela, getLista, getListaProducao, getListaHospital, getListaRadiologista
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(RelatorioHospital);